import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },

  children: {
    cursor: 'pointer'
  },

  menu: {
    fontSize: theme.size.sm,
    color: theme.palette.primary.main
  },

  icon: {
    marginLeft: '0.25rem',
    color: '#7F8487'
  },

  text: {
    marginLeft: '0.25rem',
    fontSize: theme.size.sm,
    color: '#7F8487',
    userSelect: 'none'
  }
}))

export default useStyles
